<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Pesquisar Pessoa'"></basic-toolbar>

          <v-card-text>

            <!-- Mensagem informativa -->
            <v-layout row>
              <v-flex xs12>
                <v-alert
                  class="alerta"
                  color="#00796b"
                  type="info"
                  dense
                  outlined
                >
                  Para adicionar um membro da equipe, realize a pesquisa pelo nome ou CPF da pessoa. Caso a pessoa desejada não seja encontrada, 
                  clique no botão "CADASTRAR MEMBRO EXTERNO".
                </v-alert>
              </v-flex>
            </v-layout>

            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Realiza a busca por nome ou CPF -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs6>
                    <v-radio-group v-model="tipoBusca" row>
                      <!-- Filtro por nome -->
                      <v-radio label="Nome" value="nome"></v-radio>
                      <!-- Filtro por CPF -->
                      <v-radio label="CPF" value="cpf"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs9>

                    <!-- Nome -->
                    <v-text-field
                      v-show="tipoBusca==='nome'"
                      label='Nome'
                      v-model="pessoa.nome"
                      @keyup.enter="pesquisaPessoasPorNome()"
                      max-height="400">
                    </v-text-field>

                    <!-- CPF -->
                    <v-text-field-cpf
                      v-show="tipoBusca!=='nome'"
                      label='CPF'
                      v-model="pessoa.cpf"
                      @keyup.enter="pesquisaPessoasPorCpf()"
                      v-bind:options="{
                        outputMask: '###.###.###-##',
                      }"
                    />

                  </v-flex>

                  <!-- Botão "Pesquisar" -->
                  <v-flex xs3 style="padding-top:15px">
                    
                    <!-- Pesquisar por nome -->
                    <v-btn v-if="tipoBusca==='nome'" color="primary" style="margin-left: 15px;" @click="pesquisaPessoasPorNome()">Pesquisar</v-btn>

                    <!-- Pesquisar por cpf -->
                    <v-btn v-else color="primary" style="margin-left: 15px;" @click="pesquisaPessoasPorCpf()">Pesquisar</v-btn>

                  </v-flex>
                </v-layout>
              </v-container>

            </v-form>

            <br><br>

            <v-divider></v-divider>

            <!-- Tabela com as pessoas -->
            <v-data-table
            :headers="headers"
            :items="listaPessoas"
            :search="search"
            :no-data-text="'Nenhuma pessoa encontrada'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >

              <!-- Adicionar como membro da equipe -->
              <template v-slot:item.opcoes="props">
                
                <c-tooltip-btn
                  icon="add_box"
                  color="primary"
                  tooltip="Adicionar como membro da equipe"
                  @click="toAdicionarMembroEquipe(props.item.idPessoa)"
                ></c-tooltip-btn>

              </template>

              <!-- Formata CPF -->
              <template v-slot:item.cpf="props">{{ props.item.cpf === null || props.item.cpf === '' ? '-' : props.item.cpf }}</template>

              <!-- Número total de pessoas -->
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaPessoas.length }} {{ listaPessoas.length > 1 ? 'pessoas' : 'pessoa' }}
              </template>

            </v-data-table>

            <br>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Cadastrar Membro Externo" -->
              <v-btn color="primary" @click="cadastrarMembroExterno()">Cadastrar Membro Externo</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import TootipButton from '@/components/c-tooltip-btn'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa', 'projetoPesquisa'],
    data: () => ({
      tipoBusca: 'nome',
      pessoa: {
        nome: '',
        cpf: ''
      },
      listaPessoas: [],
      projetoPesquisa: {},
      search: null,
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Nome', align: 'left', width: '50%', value: 'nomeSocial' },
        { text: 'CPF', align: 'left', width: '25%', value: 'cpf' },
        { text: 'Opções', align: 'left', width: '25%', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Pesquisa pessoa pelo nome.
      pesquisaPessoasPorNome () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' })
        projetos.getPessoasPorNome(this.pessoa.nome)
        .then(response => {
          this.listaPessoas = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' })
        })
      },

      // Pesquisa pessoa pelo CPF.
      pesquisaPessoasPorCpf () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' })
        projetos.getPessoasPorCpf(this.pessoa.cpf)
        .then(response => {
          this.listaPessoas = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' })
        })
      },

      // Cadastra um membro externo.
      cadastrarMembroExterno () {
        this.$router.push({ name: 'ProjetoPesquisaCadastrarMembroExterno', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
      },

      // Redireciona para a página anterior.
      cancelar: function () {
        this.$router.go(-1)
      },

      // Adiciona um participante ao projeto de pesquisa.
      toAdicionarMembroEquipe: function (idPessoa) {
        this.$router.push({ name: 'ProjetoPesquisaAdicionarMembroEquipe', params: {idProjetoPesquisa: this.idProjetoPesquisa, idPessoa: idPessoa} })
      }
    },
    mounted () {
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-tooltip-btn': TootipButton
    }
  }
</script>

<style scoped>

  .alerta {
    margin-top: 1.5em;
    margin-bottom: 2.0em;
  }

</style>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// pesquisar-pessoas.vue?735f954e